import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BadgeWrapper, Icon, StyledText } from './styles';
export var Badge = function (_a) {
  var children = _a.children,
    _b = _a.rounded,
    rounded = _b === void 0 ? true : _b,
    _c = _a.variant,
    variant = _c === void 0 ? 'info' : _c,
    icon = _a.icon;
  var textVariant = {
    positive: 'positive',
    neutral: 'secondary',
    negative: 'negative',
    tip: 'tip',
    warning: 'warning',
    info: 'info',
    esg: undefined,
    'share-investing': undefined
  };
  return _jsxs(BadgeWrapper, {
    variant: variant,
    rounded: rounded,
    children: [icon && _jsx(Icon, {
      size: 16,
      type: icon,
      variant: variant,
      "aria-hidden": true
    }), _jsx(StyledText, {
      el: "span",
      styleName: "bodySmall",
      variant: textVariant[variant],
      badgeVariant: variant,
      children: _jsx("strong", {
        children: children
      })
    })]
  });
};